export default "__VITE_ASSET__DCfbcp6G__"